<script setup lang="ts">
import { computed } from 'vue'

defineProps<{
  medium: string
  isFixed?: boolean
}>()
const logo = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/logo-grey.png`)
</script>

<template>
  <div class="fixed bottom-0 w-full">
    <a
      class="cursor-pointer"
      :href="`https://www.heypongo.com/?utm_source=watermark-pongo&utm_medium=${medium}&utm_campaign=booster`"
      target="_blank"
    >
      <footer
        class="flex h-10 w-full cursor-pointer items-center justify-center bg-gray-50 px-3"
        :class="isFixed && 'fixed'"
      >
        <span class="text-xs text-gray-400">{{ $t('document.footer') }}</span>
        <img class="ml-2 h-6" :src="logo" alt="logo HeyPongo" />
      </footer>
    </a>
  </div>
</template>
